import React from 'react';

import SimpleTableEditable, {standaloneProps} from 'notebook/simple-tables/SimpleTableEditable';
import {SchemaAndColumnGroup, StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import {EMPTY_PLACEHOLDER_INSERTION_CONTEXT} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';

import ResultsTableAdapter from './ResultsTableAdapter';
import {ResultsTable} from './ResultsTableConstants';

interface ResultsTablePreviewProps {
  schemaAndColumnGroup: SchemaAndColumnGroup;
  adapter: ResultsTableAdapter;
  selectorsById: {[selectorId: string]: SchemaFieldSelector};
}

export function ResultsTablePreview(props: ResultsTablePreviewProps): JSX.Element {
  const structuredTable = {
    ...props.adapter.createTable({
      name: props.schemaAndColumnGroup.name,
      schemas: [props.schemaAndColumnGroup],
      entryId: 'etr_123',
      metadata: {
        supportsManualEntry: true,
        numResults: 0,
      },
      selectorsById: props.selectorsById,
      structuredTableInsertionContext: EMPTY_PLACEHOLDER_INSERTION_CONTEXT,
    }),
    cid: '123',
  };

  const resultsTable: ResultsTable = {
    ...structuredTable,
    kind: StructuredTableKind.RESULTS,
  };

  const table = props.adapter.toTable(resultsTable);

  return (
    <FormGroup className="u-spacing-top">
      <Label>Preview</Label>
      <div className="modal-mediocre-tableWrapper">
        <SimpleTableEditable
          {...standaloneProps}
          table={table}
          cid="123"
          locked={true}
          hideFormulaBox={true}
          viewer={true}
          icon="table"
          enableFormulas={false}
          hasPlaceholderRows={true}
          storeState={() => {}}
          tableLabel={props.adapter.getDisplayName(resultsTable)}
          isLeftAlignColumnHeader={true}
        />
      </div>
    </FormGroup>
  );
}
